import { calculateRowAmounts, round2 } from '../../item-details/item-utils';
import { V2OrderLine, V2OrderSummary } from '../models/item-details-v2.models';

export function sortRowsLatestFirst(rows: V2OrderLine[]): V2OrderLine[] {
    return [...(rows || [])].sort((a, b) => Number(b.lineNumber || 0) - Number(a.lineNumber || 0));
}

export function applyPerLineEditForParity(row: V2OrderLine): V2OrderLine {
    const updated = { ...row };
    Object.assign(updated, calculateRowAmounts(updated));
    if (updated.status === 20) {
        updated.originalQuantity = updated.originalQuantity ?? updated.quantity;
        updated.status = 30;
    }
    return updated;
}

export function buildSummaryFromLines(rows: V2OrderLine[]): V2OrderSummary {
    const list = rows || [];
    const totalValue = round2(list.reduce((s, r) => s + (Number(r.amount) || 0), 0));
    const totalDiscountValue = round2(list.reduce((s, r) => s + ((Number(r.amount) * Number(r.discount || 0)) / 100 || 0), 0));
    const totalNetAmount = round2(list.reduce((s, r) => s + (Number(r.amountAfterDiscount) || 0), 0));

    const netByRate = new Map<number, number>();
    for (const row of list) {
        const vatRate = Number(row.vat) ?? 0;
        const net = Number(row.amountAfterDiscount) ?? 0;
        netByRate.set(vatRate, (netByRate.get(vatRate) ?? 0) + net);
    }

    let totalVatAmount = 0;
    netByRate.forEach((netSum, vatRate) => {
        totalVatAmount += round2((netSum * vatRate) / 100);
    });
    totalVatAmount = round2(totalVatAmount);

    return {
        totalValue,
        totalDiscountValue,
        totalNetAmount,
        totalVatAmount,
        subscription: round2(totalNetAmount + totalVatAmount)
    };
}

